import './index.scss'
import {getResByKey, getResDescByKey} from "@/util/Oem";
const useIcon = (h, that, item) => (
    <div
        class="animated bounceIn"
    >
        <div class="icon" style={`background-color:${item.backColor};color:${item.iconColor}`}>
            <i class={['bqh',item.icon]} />
        </div>
    </div>
);
const useElCol = (h, that) => {
    return that.tool.map(item => (
        <div ref="icon" class="v-tool__left__box" onClick={() => that.util.toLink(item.url)}>
            {useIcon(h,that,item)}
            <div class="title">{item.title}</div>
        </div>
    ))
};
export default {
    name: "VToolCenter",
    props: { mini: Boolean },
    data() {
        return {
            tool: [
                {
                    icon: "bqh-xiaozhushou_1",
                    iconColor: "#856fee",
                    backColor: "#d8ceff",
                    title: "",
                    url: "",
                },
                {
                    icon: "bqh-baiwang_1",
                    iconColor: "#63c77e",
                    backColor: "#c6f4d0",
                    title: "百旺开票软件",
                    url: "https://shuimofang.oss-cn-beijing.aliyuncs.com/software/百旺开票软件.zip",
                },
                {
                    icon: "bqh-jinshui_1",
                    iconColor: "#ed9116",
                    backColor: "#fedfb3",
                    title: "金税开票",
                    url: "https://shuimofang.oss-cn-beijing.aliyuncs.com/software/金税盘开票软件.exe",
                },
                {
                    icon: "bqh-zhinenggouxuan_1",
                    iconColor: "#ff788a",
                    backColor: "#ffd7dd",
                    title: "智能勾选小助手",
                    url: "https://shuimofang.oss-cn-beijing.aliyuncs.com/software/%E5%8B%BE%E9%80%89%E5%B9%B3%E5%8F%B0%E8%87%AA%E5%8A%A8%E7%99%BB%E5%BD%95.exe",
                },
                {
                    icon: "bqh-caozuoshouce_1",
                    iconColor: "#5395df",
                    backColor: "#bfe0ff",
                    title: "",
                    url: "",
                },
            ],
            loginResource:[]
        };
    },
    mounted() {
        // 临时指定域名，方便测试
        //domain = "https://magiccubex.vip";
        // this.loginResource = JSON.parse(sessionStorage.getItem('loginResource'));
        // if(!this.loginResource) return
        // this.tool[0].url = this.loginResource.find(item => item.resources_code == 'HOME_GLHT_EXE_ASSISTANT_TUTORIAL').resources_content;
        // this.tool[0].title = this.loginResource.find(item => item.resources_code == 'HOME_GLHT_EXE_ASSISTANT_TUTORIAL').resources_description;
        // this.tool[4].url = this.loginResource.find(item => item.resources_code == 'HOME_GLHT_EXE_OPERATION').resources_content;
        // this.tool[4].title = this.loginResource.find(item => item.resources_code == 'HOME_GLHT_EXE_OPERATION').resources_description;

      this.tool[0].url = getResByKey('HOME_GLHT_EXE_ASSISTANT_TUTORIAL');
      this.tool[0].title = getResDescByKey('HOME_GLHT_EXE_ASSISTANT_TUTORIAL');
      this.tool[4].url = getResByKey('HOME_GLHT_EXE_OPERATION');
      this.tool[4].title = getResDescByKey('HOME_GLHT_EXE_OPERATION');
    },
    methods: {
        toLink(url) {
            this.$router.push(url);
        },
        style() {
            this.$refs.icon.forEach((item) => {
                item.classList.add("fadeInDown");
            });
            setTimeout(() => {
                this.$refs.icon.forEach((item) => {
                    item.classList.remove("fadeInDown");
                });
            }, 1000);
        },
    },
    render(h) {
        return (
            <div class="v-tool__left">
                {useElCol(h, this)}
            </div>
        )
    },
};
